import { useEffect, useState } from "react";

import { formatUsd } from "../../shared/money";
import type { HistoryPage as HistoryData } from "../../shared/types";
import { LoadingState } from "../components/LoadingState";
import { getHistory } from "../lib/api";

export function HistoryPage() {
  const [page, setPage] = useState(1);
  const [history, setHistory] = useState<HistoryData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    void getHistory(page, 20, controller.signal)
      .then((data) => {
        setHistory(data);
        setError(null);
      })
      .catch((caught: unknown) => {
        if (caught instanceof DOMException && caught.name === "AbortError") return;
        setError(caught instanceof Error ? caught.message : "History is unavailable.");
      });
    return () => controller.abort();
  }, [page]);

  return (
    <main className="content-page history-page">
      <header className="page-intro">
        <p className="section-kicker">PERMANENT RECORD</p>
        <h1>THE PRESS HISTORY</h1>
        <p>
          Every captured press keeps its number and page. Moderation or a refund never reuses it.
        </p>
      </header>
      {history ? (
        history.items.length > 0 ? (
          <ol className="history-cards">
            {history.items.map((press) => (
              <li key={press.pressNumber}>
                <a href={`/press/${press.pressNumber}`}>
                  <span className="history-card-number">PRESS #{press.pressNumber}</span>
                  <h2>{press.displayName}</h2>
                  {press.publicMessage ? <p>{press.publicMessage}</p> : null}
                  <dl>
                    <div>
                      <dt>PAID</dt>
                      <dd>{formatUsd(press.amountSubtotalCents)}</dd>
                    </div>
                    <div>
                      <dt>STATUS</dt>
                      <dd>{press.isCurrentHolder ? "CURRENT HOLDER" : "RECORDED"}</dd>
                    </div>
                  </dl>
                </a>
              </li>
            ))}
          </ol>
        ) : (
          <div className="history-empty large-empty">
            <p>Nobody has pressed it yet.</p>
            <span>Let's keep it that way.</span>
          </div>
        )
      ) : (
        <LoadingState label="Reading the permanent record" />
      )}
      {error ? <p className="form-error">{error}</p> : null}
      {history ? (
        <nav className="pagination" aria-label="History pagination">
          <button type="button" disabled={page <= 1} onClick={() => setPage((value) => value - 1)}>
            PREVIOUS
          </button>
          <span>
            PAGE {page} · {history.total} PRESSES
          </span>
          <button
            type="button"
            disabled={!history.hasMore}
            onClick={() => setPage((value) => value + 1)}
          >
            NEXT
          </button>
        </nav>
      ) : null}
    </main>
  );
}
